'use strict';

var SeasonalityPanelDirective = function SeasonalityPanelDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/seasonality-panel.html'),
    controller: 'SeasonalityPanelController',
    link: function link(scope, element) {
      var modalElement = element.find('#seasonality-demand-reinit-confirmation-modal');
      element.on('cellendedit', scope.setEventType);
      scope.showModal = function () {
        modalElement.modal('show');
      };
      scope.$on('pooled-seasonality:profile-review-complete', scope.pooledSeasonalityReviewComplete);
      scope.$on('pooled-seasonality:publish-profile-request', scope.showParameterReview);
      scope.$on('pooled-seasonality:submit-publish-request', scope.publishCalendar);
    }
  };
};
SeasonalityPanelDirective.$inject = [];
module.exports = SeasonalityPanelDirective;